import { checkDefined } from 'faro-common-model';
export const textSnippetNameMaxLength = 250;
export const textSnippetContentMaxLength = 100000;
export const textSnippetCategoryMaxLength = 120;
/**
 * @return the built TextSnippet entity
 */
export function toTextSnippet(textSnippet) {
    checkDefined(textSnippet.id, 'TextSnippet', 'id');
    checkDefined(textSnippet.name, 'TextSnippet', 'name');
    checkDefined(textSnippet.content, 'TextSnippet', 'content');
    return {
        id: textSnippet.id,
        name: textSnippet.name,
        content: textSnippet.content,
        nctIdentifiers: textSnippet.nctIdentifiers || [],
        sources: textSnippet.sources || [],
        contentTypes: textSnippet.contentTypes || [],
        therapeuticAreas: textSnippet.therapeuticAreas || [],
        diseaseAreas: textSnippet.diseaseAreas || [],
        deleted: textSnippet.deleted || false,
        created: textSnippet.created,
        updated: textSnippet.updated,
    };
}
//# sourceMappingURL=text-snippet.js.map